import { Chat } from '@repo/db'
import { useKeycloak } from '@web/modules/core'
import { EventGoal, EventOrigin, logEvent } from '@web/analytics'
import { AnalyticsEvents } from '@repo/types/src/enums/AnalyticsEvents'
import { PLATFORM } from '@repo/core'
import { useSendOrderMessageForm } from '@repo/core/src/send-order-message'

export const useSendOrderMessageFormWeb = (chat: Chat) => {
  const { currentUser } = useKeycloak()
  const { form } = useSendOrderMessageForm(chat, currentUser?.keycloakId)

  logEvent({
    name: AnalyticsEvents.VISUALIZAR_AREA_COBRANCA,
    params: {
      origin: EventOrigin.modal,
      goal: EventGoal.click,
      platform: PLATFORM.WEB,
      connectionKey: chat.connectionKey
    }
  })

  return {
    form
  }
}
